export default __webpack_public_path__ + "static/media/bartolome-gandino.ab1a31d8.webp";